// extracted by mini-css-extract-plugin
export default {"date":"DateRangePeriod_date__NsjCd","over":"DateRangePeriod_over__nM2E-"};